var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isScrolledDown)?_c('Breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs,"truncateTo":25}}):_vm._e(),_c('h1',[_vm._v(_vm._s(_vm._f("translate")('where_do_you_want_to_go')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }